module.exports = __webpack_public_path__ + "img/facial_hair_chin_mustache_thick_rect.090f8cb1.png";